import React, { Component } from "react";
import axios from "axios";
import { Table, Space } from "antd";
import moment from "moment";
import Scontrino from './Scontrino';


export default class TransactionsTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      transactions: [],
    };
  }

  componentDidMount() {
    this.fetchTransactions();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.cardId !== this.props.cardId) {
      this.fetchTransactions();
    }
  }

  async fetchTransactions() {
    await axios
      .get(
        `${process.env.REACT_APP_SERVER_URL}/api/clienti/GetTransactions?cardId=${this.props.cardId}`
      )
      .then((response) => {
        console.log(response.data.hits);
        // handle success
        this.setState({ notFound: false, transactions: response.data.hits });
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed

        console.log(this.state.transactions);
      });
  }

  renderScontrino(scontrini) {
    if (scontrini.length === 0) {
      return <b>Non abbiamo informazioni su questo scontrino</b>

    }

    return scontrini.map((scontrino) => (
      <Scontrino key={scontrino.productId} scontrino={scontrino} />
    ));
  }

  render() {
    const columns = [
      {
        title: "ID",
        dataIndex: "id",
        key: "id",
        render: (text, tx) => (
          <Space size="middle" key={tx._id}>
            <p>{tx._id}</p>
          </Space>
        ),
      },

      {
        title: "Data",
        dataIndex: "data",
        key: "data",
        render: (text, tx) => (
          <Space size="middle" key={tx._id}>
            <p>{moment(tx._source.dateTime).format("DD-MM-YYYY hh:mm")}</p>
          </Space>
        ),
      },

      {
        title: "Punti",
        dataIndex: "punti",
        key: "punti",
        render: (text, tx) => (
          <Space size="middle" key={tx._id}>
            <p>{tx._source.punti}</p>
          </Space>
        ),
      },
    ];
    return (
      <Table rowKey={tx => tx._id} dataSource={this.state.transactions} columns={columns} expandable={{
        expandedRowRender: (tx) =>
          this.renderScontrino(tx._source.scontrino),
          rowExpandable: (tx) => tx._source.cardId !== "Not Expandable",
      }} />
    );
  }
}
